<template>
  <div v-if="show_">
    <div class="mask"></div>
    <div class="index-wrap">
      <div class="title">关注公众号</div>
      <img :src="img">
      <div class="con">{{text}}</div>
      <div class="cha"><span @click="close"> × </span></div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    img: {
      type: String
    },
    text: {
      type: String
    }
  },
  data() {
    return {
      show_: false
    }
  },
  created() {
  },
  methods: {
    close() {
      this.show_ = false
    }
  },
  watch: {
    show: function (val) {
      this.show_ = val
    }
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .mask
    position fixed
    left 0
    top 0
    right 0
    bottom 0
    background rgba(0,0,0,.4)
    z-index 998
  .index-wrap
    position fixed
    left 50%
    top 50%
    transform translate(-50%,-50%)
    z-index 999
    background #ffffff
    font-size size(32)
    text-align center
    min-width 60%
    padding size(30) size(24) size(40)
    border-radius 4px
    img
      display block
      width size(200)
      margin size(18) auto size(24)
  .title
    font-size size(30)
    line-height 2
    color #333
    font-weight 800
  .con
    font-size size(24)
    line-height 1.6
  .cha
    position absolute
    text-align center
    width 100%
    left 0
    bottom size(-90)
    color #fff
    >span
      display inline-block
      color #fff
      font-size size(40)
      width size(44)
      height size(44)
      border-radius 50%
      border 1px solid #fff
      line-height size(36)
      text-align center
</style>



// WEBPACK FOOTER //
// src/components/base/qr-popup/index.vue